/* Saduq Care — theme.js (no dependencies) */
(() => {
  'use strict';

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const isRTL = () => document.documentElement.dir === 'rtl';
  const T = window.theme || { routes: {}, strings: {} };

  /* ---------- money ---------- */
  function formatMoney(cents, format = T.moneyFormat || '{{amount}}') {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const fmt = (n, d = 2, t = ',', dec = '.') => {
      if (isNaN(n) || n == null) return 0;
      n = (n / 100).toFixed(d);
      const parts = n.split('.');
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + t) + (parts[1] ? dec + parts[1] : '');
    };
    const m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    let v = '';
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': v = fmt(cents, 0); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
      case 'amount_no_decimals_with_space_separator': v = fmt(cents, 0, ' '); break;
      default: v = fmt(cents, 2);
    }
    // match Liquid's money_without_trailing_zeros used across the theme
    return format.replace(/\{\{\s*\w+\s*\}\}/, v.replace(/[.,]00$/, ''));
  }
  window.formatMoney = formatMoney;
  // whole-number money in the shop format (e.g. "LE 1,699") — used for Sultan cart/ship copy
  const formatMoney0 = (cents, format = T.moneyFormat || '{{amount}}') =>
    format.replace(/\{\{\s*\w+\s*\}\}/, Math.round(cents / 100).toLocaleString('en-US'));
  window.formatMoney0 = formatMoney0;

  /* ---------- toast ---------- */
  let toastTimer;
  function toast(msg) {
    const el = $('[data-toast]');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => (el.hidden = true), 2600);
  }
  window.themeToast = toast;

  /* ---------- drawers ---------- */
  function openDrawer(id) {
    const d = document.getElementById(id);
    if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    const f = d.querySelector('[data-drawer-close]');
    if (f) setTimeout(() => f.focus({ preventScroll: true }), 50);
  }
  function closeDrawers() {
    $$('.drawer.is-open').forEach((d) => {
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
    });
    document.body.classList.remove('is-locked');
  }
  window.openDrawer = openDrawer;
  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-drawer-open]');
    if (o) {
      if (o.dataset.drawerOpen === 'CartDrawer' && T.cartType !== 'drawer') return;
      e.preventDefault();
      openDrawer(o.dataset.drawerOpen);
      return;
    }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); closeDrawers(); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { closeDrawers(); closeVideo(); }
  });

  /* ---------- carousels ---------- */
  function initCarousel(root) {
    if (root.dataset.carouselReady) return;
    root.dataset.carouselReady = '1';
    const track = root.querySelector('.scroller');
    if (!track) return;
    const prev = root.querySelector('[data-dir="prev"]');
    const next = root.querySelector('[data-dir="next"]');
    const dotsWrap = root.querySelector('.sc-dots');
    const items = () => Array.from(track.children);
    const step = () => {
      const first = items()[0];
      if (!first) return track.clientWidth;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return first.getBoundingClientRect().width + gap;
    };
    // scrollLeft is negative in RTL (Chrome/Firefox/Safari spec behaviour)
    const pos = () => Math.abs(track.scrollLeft);
    const max = () => track.scrollWidth - track.clientWidth;
    const by = (dir) => {
      const sign = isRTL() ? -1 : 1;
      track.scrollBy({ left: dir * step() * sign, behavior: 'smooth' });
    };
    let pages = 0;
    const buildDots = () => {
      if (!dotsWrap) return;
      const per = Math.max(1, Math.floor(track.clientWidth / step()));
      pages = max() <= 2 ? 1 : Math.ceil(max() / (per * step())) + 1;
      dotsWrap.innerHTML = '';
      if (pages <= 1) { dotsWrap.hidden = true; return; }
      dotsWrap.hidden = false;
      for (let i = 0; i < pages; i++) {
        const b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', String(i + 1));
        b.addEventListener('click', () => {
          const target = Math.min(max(), i * per * step());
          track.scrollTo({ left: isRTL() ? -target : target, behavior: 'smooth' });
        });
        dotsWrap.appendChild(b);
      }
    };
    const update = () => {
      const p = pos();
      if (prev) prev.disabled = p <= 2;
      if (next) next.disabled = p >= max() - 2;
      if (dotsWrap && pages > 1) {
        const idx = max() <= 0 ? 0 : Math.round((p / max()) * (pages - 1));
        Array.from(dotsWrap.children).forEach((d, i) => d.classList.toggle('is-active', i === idx));
      }
    };
    prev && prev.addEventListener('click', () => by(-1));
    next && next.addEventListener('click', () => by(1));
    track.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
    window.addEventListener('resize', () => { buildDots(); update(); });
    buildDots();
    update();

    // autoplay
    const delay = parseInt(root.dataset.autoplay || '0', 10);
    if (delay > 0) {
      let timer;
      const play = () => {
        stop();
        timer = setInterval(() => {
          if (pos() >= max() - 2) track.scrollTo({ left: 0, behavior: 'smooth' });
          else by(1);
        }, delay);
      };
      const stop = () => clearInterval(timer);
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', play);
      root.addEventListener('touchstart', stop, { passive: true });
      new IntersectionObserver((en) => en.forEach((x) => (x.isIntersecting ? play() : stop()))).observe(root);
    }
  }
  const initCarousels = (scope = document) => $$('[data-carousel]', scope).forEach(initCarousel);
  window.initCarousels = initCarousels;

  /* ---------- quantity ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qty-btn]');
    if (!b) return;
    const input = b.closest('.qty').querySelector('input');
    const min = parseInt(input.min || '0', 10);
    let v = parseInt(input.value || '1', 10) + (b.dataset.qtyBtn === 'plus' ? 1 : -1);
    if (v < min) v = min;
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- cart ---------- */
  const cartSections = () => {
    const ids = ['cart-drawer', 'cart-count'];
    $$('[data-cart-section]').forEach((el) => ids.push(el.dataset.cartSection));
    return Array.from(new Set(ids));
  };
  function renderSections(sections) {
    if (!sections) return;
    Object.entries(sections).forEach(([id, html]) => {
      if (!html) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      if (id === 'cart-count') {
        const n = doc.querySelector('[data-count]');
        $$('[data-cart-count]').forEach((el) => {
          el.textContent = n ? n.dataset.count : '0';
        });
        return;
      }
      const fresh = doc.querySelector(`[data-cart-root="${id}"]`);
      const old = document.querySelector(`[data-cart-root="${id}"]`);
      if (fresh && old) {
        old.innerHTML = fresh.innerHTML;
        initCarousels(old);
      }
    });
  }
  /* free-shipping boxes outside the re-rendered cart (e.g. product page) */
  function updateShip(total) {
    if (total == null || isNaN(total)) return;
    $$('[data-sp-ship]').forEach((box) => {
      if (box.closest('[data-cart-root]')) return; // re-rendered by the server
      const th = +box.dataset.th, left = th - total, f = box.dataset.fmt;
      box.dataset.total = total;
      box.classList.toggle('is-done', left <= 0);
      const bar = box.querySelector('[data-sp-ship-i]');
      if (bar) bar.style.width = Math.min(100, Math.max(0, (total / th) * 100)) + '%';
      const t = box.querySelector('[data-sp-ship-t]');
      if (t) t.innerHTML = total <= 0
        ? `🚚 الشحن مجاني على الطلبات من <b>${formatMoney0(th, f)}</b>`
        : left > 0 ? `فاضلك <b>${formatMoney0(left, f)}</b> وتوصل للشحن المجاني 🚚` : 'مبروك! الشحن عليك مجاني 🎉';
    });
  }
  window.updateShip = updateShip;
  async function cartTotal() {
    const box = document.querySelector('[data-cart-root="cart-drawer"] [data-sp-ship]');
    if (box && box.dataset.total !== undefined) return +box.dataset.total;
    try { return (await (await fetch(`${T.routes.cart}.js`)).json()).total_price; } catch (_) { return null; }
  }
  async function afterAdd() {
    const total = await cartTotal();
    updateShip(total);
    const box = document.querySelector('[data-sp-ship]');
    const th = box ? +box.dataset.th : T.freeShipping;
    if (total == null || !th) { toast(T.strings.added); return; }
    toast(total >= th ? 'اتضاف للسلة ✓ · الشحن عليك مجاني 🎉' : `اتضاف للسلة ✓ · فاضلك ${formatMoney0(th - total)} للشحن المجاني`);
  }

  async function addToCart(formData, btn, opts = {}) {
    btn && btn.classList.add('is-loading');
    formData.append('sections', cartSections().join(','));
    formData.append('sections_url', window.location.pathname);
    try {
      const res = await fetch(`${T.routes.cartAdd}.js`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || T.strings.error);
      if (opts.silent) return data; // buy now → caller redirects to checkout
      renderSections(data.sections);
      document.dispatchEvent(new CustomEvent('cart:added', { detail: data }));
      const onCartPage = !!document.querySelector('[data-cart-section]');
      if (!onCartPage && T.cartType === 'drawer' && document.getElementById('CartDrawer')) openDrawer('CartDrawer');
      else if (!onCartPage) window.location.href = T.routes.cart;
      afterAdd();
      if (btn) {
        const label = btn.querySelector('[data-label]');
        if (label) {
          const old = label.textContent;
          label.textContent = T.strings.added;
          setTimeout(() => (label.textContent = old), 1600);
        }
      }
      return data;
    } catch (err) {
      toast(err.message);
      throw err;
    } finally {
      btn && btn.classList.remove('is-loading');
    }
  }
  window.addToCart = addToCart;

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-ajax-add]');
    if (!form) return;
    e.preventDefault();
    const btn = e.submitter && e.submitter.matches('[type=submit]') ? e.submitter : form.querySelector('[type=submit]');
    const fd = new FormData(form);
    if (btn && btn.hasAttribute('data-buy-now')) {
      addToCart(fd, btn, { silent: true }).then(() => (window.location.href = '/checkout')).catch(() => {});
      return;
    }
    addToCart(fd, btn).catch(() => {});
  });

  // Buy now outside the form (uses form attribute)
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-buy-now-btn]');
    if (!b) return;
    e.preventDefault();
    const form = document.getElementById(b.dataset.form);
    if (!form) return;
    b.classList.add('is-loading');
    const fd = new FormData(form);
    fetch(`${T.routes.cartAdd}.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
      .then((r) => r.json())
      .then((d) => {
        if (d.status) throw new Error(d.description);
        window.location.href = '/checkout';
      })
      .catch((err) => { b.classList.remove('is-loading'); toast(err.message || T.strings.error); });
  });

  /* Sultan quick add: any [data-sl-add="<variant id>"] button (suggestions, pairs, cross-sell) */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-sl-add]');
    if (!b) return;
    e.preventDefault();
    if (b.disabled) return;
    const fd = new FormData();
    fd.append('id', b.dataset.slAdd);
    fd.append('quantity', b.dataset.q || '1');
    b.disabled = true;
    addToCart(fd, b).catch(() => {}).finally(() => (b.disabled = false));
  });

  /* "خليها كيلو بدل 500": remove the 500 جم line and add the kilo with the same quantity */
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-sl-upg]');
    if (!b) return;
    e.preventDefault();
    if (b.disabled) return;
    b.disabled = true;
    const root = b.closest('[data-cart-root]');
    root && root.classList.add('is-busy');
    try {
      const r1 = await fetch(`${T.routes.cartChange}.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: b.dataset.slUpg, quantity: 0 })
      });
      if (!r1.ok) throw new Error(T.strings.error);
      const r2 = await fetch(`${T.routes.cartAdd}.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: +b.dataset.v, quantity: +(b.dataset.q || 1) }], sections: cartSections(), sections_url: window.location.pathname })
      });
      const d = await r2.json();
      if (!r2.ok || d.status) throw new Error(d.description || T.strings.error);
      renderSections(d.sections);
      document.dispatchEvent(new CustomEvent('cart:changed', { detail: d }));
      afterAdd();
    } catch (err) {
      toast(err.message || T.strings.error);
      b.disabled = false;
    } finally {
      root && root.classList.remove('is-busy');
    }
  });

  /* [data-sl-v="<variant id>"]: pick that variant in the page's variant picker (e.g. "خليها كيلو" ✓) */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-sl-v]');
    if (!b) return;
    e.preventDefault();
    const picker = $('[data-variant-picker]');
    const json = picker && picker.querySelector('[data-product-json]');
    if (!json) return;
    const v = JSON.parse(json.textContent).variants.find((x) => String(x.id) === b.dataset.slV);
    if (!v) return;
    let last;
    v.options.forEach((val, i) => {
      $$(`input[data-option-index="${i}"]`, picker).forEach((inp) => {
        if (inp.type === 'radio' && inp.value === val) { inp.checked = true; last = inp; }
        else if (inp.tagName === 'SELECT') { inp.value = val; last = inp; }
      });
    });
    last && last.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* drag-to-scroll for suggestion tracks (mouse; touch scrolls natively) */
  let drag = null;
  document.addEventListener('pointerdown', (e) => {
    const t = e.pointerType === 'mouse' && e.button === 0 && e.target.closest('[data-drag]');
    if (!t || e.target.closest('button')) return;
    drag = { t, x: e.clientX, left: t.scrollLeft, moved: false };
  });
  document.addEventListener('pointermove', (e) => {
    if (!drag) return;
    const dx = e.clientX - drag.x;
    if (Math.abs(dx) > 4) { drag.moved = true; drag.t.classList.add('is-dragging'); }
    if (drag.moved) drag.t.scrollLeft = drag.left - dx;
  });
  document.addEventListener('pointerup', () => {
    if (!drag) return;
    const d = drag;
    drag = null;
    d.t.classList.remove('is-dragging');
    if (d.moved) {
      const stop = (ev) => { ev.preventDefault(); ev.stopPropagation(); };
      d.t.addEventListener('click', stop, { capture: true, once: true });
      setTimeout(() => d.t.removeEventListener('click', stop, { capture: true }), 50);
    }
  });
  document.addEventListener('dragstart', (e) => { if (e.target.closest && e.target.closest('[data-drag]')) e.preventDefault(); });

  let changeQueue = Promise.resolve();
  function changeLine(line, quantity, root) {
    root && root.classList.add('is-busy');
    changeQueue = changeQueue.then(() =>
      fetch(`${T.routes.cartChange}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity, sections: cartSections(), sections_url: window.location.pathname })
      })
        .then((r) => r.json())
        .then((d) => {
          if (d.status) throw new Error(d.description || d.message);
          renderSections(d.sections);
          updateShip(d.total_price);
          document.dispatchEvent(new CustomEvent('cart:changed', { detail: d }));
        })
        .catch((err) => toast(err.message || T.strings.error))
        .finally(() => root && root.classList.remove('is-busy'))
    );
  }
  document.addEventListener('change', (e) => {
    const i = e.target.closest('[data-line-qty]');
    if (!i) return;
    changeLine(parseInt(i.dataset.lineQty, 10), parseInt(i.value, 10), i.closest('[data-cart-root]'));
  });
  document.addEventListener('click', (e) => {
    const r = e.target.closest('[data-line-remove]');
    if (!r) return;
    e.preventDefault();
    changeLine(parseInt(r.dataset.lineRemove, 10), 0, r.closest('[data-cart-root]'));
  });

  /* ---------- variant picker ---------- */
  function initProductForm(root) {
    if (root.dataset.pfReady) return;
    root.dataset.pfReady = '1';
    const jsonEl = root.querySelector('[data-product-json]');
    if (!jsonEl) return;
    const product = JSON.parse(jsonEl.textContent);
    const idInputs = $$(`input[name="id"][form="${root.dataset.formId}"], #${root.dataset.formId} input[name="id"]`);
    const update = () => {
      const selected = $$('input[data-option-index], select[data-option-index]', root)
        .filter((i) => (i.type === 'radio' ? i.checked : true))
        .sort((a, b) => a.dataset.optionIndex - b.dataset.optionIndex)
        .map((i) => i.value);
      const v = product.variants.find((x) => x.options.every((o, k) => o === selected[k]));
      $$('span[data-option-value]', root).forEach((el) => {
        el.textContent = selected[parseInt(el.dataset.optionValue, 10)] || '';
      });
      if (!v) return;
      idInputs.forEach((i) => (i.value = v.id));
      $$('[data-variant-price]').forEach((el) => (el.textContent = formatMoney(v.price)));
      $$('[data-variant-compare]').forEach((el) => {
        el.textContent = v.compare_at_price > v.price ? formatMoney(v.compare_at_price) : '';
        el.hidden = !(v.compare_at_price > v.price);
      });
      $$('[data-variant-save]').forEach((el) => {
        const on = v.compare_at_price > v.price;
        el.hidden = !on;
        if (on) el.querySelector('[data-pct]').textContent = Math.round(((v.compare_at_price - v.price) * 100) / v.compare_at_price) + '%';
      });
      $$('[data-buy-now], [data-buy-now-btn]').forEach((b) => (b.disabled = !v.available));
      $$('[data-atc]').forEach((b) => {
        b.disabled = !v.available;
        const l = b.querySelector('[data-label]');
        if (l) l.textContent = v.available ? (b.dataset.addLabel || T.strings.addToCart) : (b.dataset.soldLabel || T.strings.soldOut);
      });
      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v, root } }));
      if (v.featured_media) document.dispatchEvent(new CustomEvent('variant:media', { detail: { mediaId: v.featured_media.id } }));
      if (root.dataset.updateUrl !== 'false') {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    };
    root.addEventListener('change', (e) => { if (e.target.matches('[data-option-index]')) update(); });
  }
  const initProductForms = (scope = document) => $$('[data-variant-picker]', scope).forEach(initProductForm);

  /* ---------- gallery (main + thumbs) ---------- */
  function initGallery(root) {
    if (root.dataset.galReady) return;
    root.dataset.galReady = '1';
    const track = root.querySelector('[data-gallery-track]');
    const thumbs = $$('[data-gallery-thumb]', root);
    if (!track) return;
    const slides = () => Array.from(track.children);
    const go = (i) => {
      const s = slides()[i];
      if (!s) return;
      // gallery slides are full-width, so slide i sits at i * clientWidth (negative in RTL)
      track.scrollTo({ left: (isRTL() ? -1 : 1) * i * track.clientWidth, behavior: 'smooth' });
      thumbs.forEach((t, k) => t.classList.toggle('is-active', k === i));
    };
    thumbs.forEach((t, i) => t.addEventListener('click', () => go(i)));
    track.addEventListener('scroll', () => {
      const w = track.clientWidth;
      const i = Math.round(Math.abs(track.scrollLeft) / w);
      thumbs.forEach((t, k) => t.classList.toggle('is-active', k === i));
      const dots = $$('.sc-dots button', root);
      dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
    }, { passive: true });
    document.addEventListener('variant:media', (e) => {
      const i = slides().findIndex((s) => s.dataset.mediaId == e.detail.mediaId);
      if (i > -1) go(i);
    });
    const start = parseInt(root.dataset.startIndex || '0', 10);
    if (start > 0) requestAnimationFrame(() => {
      track.scrollTo({ left: (isRTL() ? -1 : 1) * start * track.clientWidth });
      thumbs.forEach((t, k) => t.classList.toggle('is-active', k === start));
    });
    const dotsWrap = root.querySelector('[data-gallery-dots]');
    if (dotsWrap && slides().length > 1) {
      slides().forEach((_, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', String(i + 1));
        if (i === 0) b.classList.add('is-active');
        b.addEventListener('click', () => go(i));
        dotsWrap.appendChild(b);
      });
    }
  }
  const initGalleries = (scope = document) => $$('[data-gallery]', scope).forEach(initGallery);

  /* ---------- video modal ---------- */
  let vmodal;
  function openVideo(src, type, ratio) {
    closeVideo();
    vmodal = document.createElement('div');
    vmodal.className = 'vmodal';
    const wide = ratio && ratio !== '9/16';
    const media =
      type === 'embed'
        ? `<iframe src="${src}" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>`
        : `<video src="${src}" controls autoplay playsinline></video>`;
    vmodal.innerHTML = `<div class="vmodal__box${wide ? ' vmodal__box--wide' : ''}" style="--vratio:${ratio || '9/16'}"><button type="button" class="vmodal__close" aria-label="close"><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M6 6l12 12M18 6L6 18"/></svg></button>${media}</div>`;
    vmodal.addEventListener('click', (e) => { if (e.target === vmodal || e.target.closest('.vmodal__close')) closeVideo(); });
    document.body.appendChild(vmodal);
    document.body.classList.add('is-locked');
  }
  function closeVideo() {
    if (!vmodal) return;
    vmodal.remove();
    vmodal = null;
    if (!$('.drawer.is-open')) document.body.classList.remove('is-locked');
  }
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-video-open]');
    if (!b) return;
    e.preventDefault();
    openVideo(b.dataset.videoOpen, b.dataset.videoType || 'file', b.dataset.videoRatio);
  });

  /* ---------- before / after ---------- */
  function initBA(root) {
    if (root.dataset.baReady) return;
    root.dataset.baReady = '1';
    const range = root.querySelector('input[type=range]');
    const set = (v) => root.style.setProperty('--ba', v + '%');
    range && range.addEventListener('input', () => set(range.value));
    set(range ? range.value : 50);
  }
  const initBAs = (scope = document) => $$('[data-ba]', scope).forEach(initBA);

  /* ---------- accordions: one-open groups ---------- */
  document.addEventListener('toggle', (e) => {
    const d = e.target;
    if (!(d instanceof HTMLDetailsElement) || !d.open) return;
    const g = d.closest('[data-acc-group]');
    if (!g) return;
    $$('details[open]', g).forEach((x) => x !== d && x.closest('[data-acc-group]') === g && (x.open = false));
  }, true);

  /* footer accordions start closed on mobile */
  function footerAcc() {
    const mobile = window.matchMedia('(max-width: 989px)').matches;
    $$('[data-footer-acc]').forEach((d) => (d.open = !mobile));
  }

  /* ---------- predictive search ---------- */
  function initSearch(form) {
    if (form.dataset.psReady) return;
    form.dataset.psReady = '1';
    const input = form.querySelector('input[name="q"]');
    const box = form.querySelector('[data-predictive-results]');
    const sugg = form.querySelector('[data-search-sugg]');
    if (!input || !box) return;
    let t, ctrl;
    const hide = () => { box.hidden = true; if (sugg) sugg.hidden = true; };
    input.addEventListener('focus', () => { if (!input.value.trim() && sugg) sugg.hidden = false; });
    input.addEventListener('input', () => {
      clearTimeout(t);
      const q = input.value.trim();
      if (sugg) sugg.hidden = !!q;
      if (!q) { box.hidden = true; return; }
      t = setTimeout(async () => {
        ctrl && ctrl.abort();
        ctrl = new AbortController();
        try {
          const r = await fetch(`${T.routes.search}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`, { signal: ctrl.signal });
          const d = await r.json();
          const items = (d.resources && d.resources.results && d.resources.results.products) || [];
          box.innerHTML = items.length
            ? items.map((p) => `<a class="predictive__item" href="${p.url}">${p.image ? `<img src="${p.image}&width=120" alt="" loading="lazy">` : ''}<span><span class="predictive__title">${p.title}</span><br><span class="predictive__price">${formatMoney(Math.round(parseFloat(p.price) * 100))}</span></span></a>`).join('') +
              `<a class="predictive__all" href="${T.routes.root.replace(/\/$/, '')}/search?q=${encodeURIComponent(q)}&options[prefix]=last">${T.strings.viewAll}</a>`
            : `<div class="predictive__empty">${T.strings.noResults}</div>`;
          box.hidden = false;
        } catch (_) {}
      }, 220);
    });
    document.addEventListener('click', (e) => { if (!form.contains(e.target)) hide(); });
  }
  const initSearches = (scope = document) => $$('[data-predictive]', scope).forEach(initSearch);

  /* ---------- sticky add to cart ---------- */
  function initSticky() {
    const bar = $('[data-sticky-atc]');
    const anchor = $('[data-main-atc]');
    if (!bar || !anchor) return;
    document.body.classList.add('has-sticky-atc-ready');
    // show the bar only once every buy button has scrolled up under the sticky header
    const hd = $('.section-header') || $('[data-header]');
    const hh = hd ? Math.round(hd.getBoundingClientRect().height) : 0;
    new IntersectionObserver(([en]) => {
      const show = !en.isIntersecting && en.boundingClientRect.bottom <= hh + 1;
      bar.classList.toggle('is-visible', show);
      document.body.classList.toggle('has-sticky-atc', show);
    }, { rootMargin: `-${hh}px 0px 0px 0px` }).observe(anchor);
  }

  /* ---------- reveal ---------- */
  function initReveal(scope = document) {
    const els = $$('[data-reveal]', scope);
    if (!('IntersectionObserver' in window)) { els.forEach((e) => e.classList.add('is-in')); return; }
    const io = new IntersectionObserver((en) => en.forEach((x) => { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } }), { rootMargin: '0px 0px -8% 0px' });
    els.forEach((e) => io.observe(e));
  }

  /* ---------- read more ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-readmore]');
    if (!b) return;
    const t = document.getElementById(b.dataset.readmore);
    if (!t) return;
    t.classList.toggle('is-open');
    b.hidden = t.classList.contains('is-open');
  });

  /* back to top */
  document.addEventListener('click', (e) => { if (e.target.closest('[data-back-top]')) window.scrollTo({ top: 0, behavior: 'smooth' }); });

  /* ---------- boot ---------- */
  function boot(scope = document) {
    initCarousels(scope);
    initProductForms(scope);
    initGalleries(scope);
    initBAs(scope);
    initSearches(scope);
    initReveal(scope);
  }
  document.addEventListener('DOMContentLoaded', () => {
    boot();
    initSticky();
    footerAcc();
  });
  document.addEventListener('shopify:section:load', (e) => { boot(e.target); initSticky(); });
  window.themeBoot = boot;
})();
